import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=efac94b6&scoped=true"
var script = {}
import style0 from "./Page404.vue?vue&type=style&index=0&id=efac94b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efac94b6",
  null
  
)

export default component.exports